/**
 * Backend configuration utility
 * 
 * See docs/configuration.md for more details.
 */

// Throws an error if the environment variable is not set
function requireEnv(name: string): string {
  const value = import.meta.env[name];
  if (value === undefined || value === '') {
    const mode = import.meta.env.MODE ?? 'unknown';
    throw new Error(
      `Missing required env: ${name}. Set it in .env.${mode} or .env.${mode}.local. See docs/configuration.md.`,
    );
  }
  return value;
}

/**
 * Gets the licensee API base URL from environment variables
 */
export function getLicenseeApiUrl(): string {
  return requireEnv('VITE_LICENSEE_API_URL');
}

/**
 * Gets the primary domain from environment variables
 */
export function getPrimaryDomain(): string {
  return requireEnv('VITE_PRIMARY_DOMAIN');
}

/**
 * Gets the domain to look up in the licensee API
 * 
 * Priority:
 * 1. VITE_LICENSEE_DOMAIN env var (if set) - only used during local development to override the domain lookup
 * 2. Returns null to indicate window.location.hostname should be used
 * 
 * This allows local developers to override the domain lookup when connecting
 * to staging/production backends from localhost frontend.
 */
export function getLicenseeDomainOverride(): string | null {
  if (import.meta.env.MODE === 'production') {
    return null;
  }
  const envDomain = import.meta.env.VITE_LICENSEE_DOMAIN;
  return envDomain ?? null;
}
